import React from 'react';
import ItemBatchPage from '../components/ItemBatchPage';

const ItemBatchContainer = () => {
  return <ItemBatchPage />;
};

export default ItemBatchContainer;
